import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { CategoryLan } from '../shared/models/CategoryLan';
import { Events } from '../shared/models/Events';
import { TranslateRelLabelVO } from '../shared/models/TranslateRelLabelVO';

@Component({
  selector: 'app-tovpil-electov-choose-confirm',
  templateUrl: './tovpil-electov-choose-confirm.component.html',
  styleUrls: ['./tovpil-electov-choose-confirm.component.scss'],
  providers: [DatePipe]
})
export class TovpilElectovChooseConfirmComponent implements OnInit {
  evt?: Events;
  lstRespTranslate: TranslateRelLabelVO[];
  welcomeId:string;
  password:string;
  language:string;
  region:string;
  message:string;
  
  event_group_name_?:string;
  event_msg_success_?:string;
  thanks_for_participating_?:string;
  descript_date_?:string;

  constructor(
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.welcomeId = params.welcomeId.substr(10, params.welcomeId.length);
          this.password = params.welcomeId.substr(0, 10);
          this.language = params.group.substr(0, 2);
          this.region = params.group.substr(3, 4);
          this.message=params.message;
        });
    this.apiService.getEventByShortName(
      {
        'shortName': this.welcomeId
      }
    ).then(
      event => {
        this.evt = event;
        this.getTranslatedLabels();
      });
    
  }
  getTranslatedLabels() {
    
    let currentDate =this.datepipe.transform(new Date(), 'yyyyMMdd');
    let map = new Map();
    let mapMonths = new Map();
    let lstCat: CategoryLan[];
    this.apiService.listByLanguageMultFields(
      {
        'language': this.language,
        'region': this.region,
        'lstLabels': [
          'event_group_name_',
          'event_msg_success_',
          'thanks_for_participating_',
          'descript_date_'
          ]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.event_group_name_ = map.get('event_group_name_');
        
        if(this.message==null || this.message==''){
          this.event_msg_success_ = map.get('event_msg_success_');
           this.thanks_for_participating_ = map.get('thanks_for_participating_');
        }else{
          this.event_msg_success_ =  this.message;;
          this.thanks_for_participating_ = ' ';
        }
        
        
        this.apiService.getCategoryLang(
          {
            'language': this.language,
            'fieldId': 'months'
          }
        ).then(

          categs => {
            
            lstCat = categs;
            lstCat.forEach((element) => {
              if (element.descripTo != null) {
                mapMonths.set(element.fieldVal, element.descripTo);
              } else {
                mapMonths.set(element.fieldVal, element.descrip);
              }
            });
            this.descript_date_ =  currentDate.substr(6,2)+"-"+mapMonths.get(currentDate.substr(4,2))+"-" +currentDate.substr(0,4);
         
          });

        
      });
    }
}
